import clevertap from "clevertap-web-sdk";
import { IS_PROD, CLEVERTAP_CONFIG } from "../config";

let initialized = false;

export function initCleverTap(): any {
    if (initialized) return clevertap;

    // clevertap.privacy.push({ optOut: false });
    clevertap.privacy.push({ useIP: false });
    clevertap.setOffline(false)

    clevertap.init(
        CLEVERTAP_CONFIG.PROJECT_ID,
        CLEVERTAP_CONFIG.REGION,
        '',
        CLEVERTAP_CONFIG.TOKEN,
    );

    if (!IS_PROD) {
        clevertap.setLogLevel(3)
    }

    initialized = true;
    return clevertap;
}

export default clevertap;
